import { getSsContext, getSupportDataForDataSource } from '../selectors/form-manager.selectors';
import {
  fetchDataSourceFromLocalStore,
  fetchSupportDataSourceFromServer,
  getLanguageDataSource,
} from '../utils/actions/data-source.actions.utils';

export const UPDATE_DATASOURCE_LIST = 'UPDATE_DATASOURCE_LIST';
export const REPLACE_FROM_CHANGED_DATASOURCE_LIST = 'REPLACE_FROM_CHANGED_DATASOURCE_LIST';

export const updateDatasourceList = ({ datasource }) => ({
  type: UPDATE_DATASOURCE_LIST,
  payload: {
    datasource,
  },
});

export function fetchDataSource({
  index,
  dataSource,
  dataSourceFilter = {},
  dataSourceFilterFromDataSource,
  formKey,
  pageLimit,
  entityName,
  isEditor,
  isGridInitialization = false,
  disableCache,
}) {
  return async (dispatch, getState) => {
    const state = getState();
    const ssContext = getSsContext(state, { index, formKey, entityName });
    const { isOnline } = state.networkStatus;

    if (dataSource.dataSourceTypeStr === 'FORMDATA') {
      return await fetchDataSourceFromLocalStore({
        dataSource,
        dataSourceFilter: isGridInitialization ? dataSourceFilterFromDataSource : dataSourceFilter,
        ssContext,
        isEditor,
      });
    } else if (dataSource.dataSourceTypeStr === 'SETTINGS') {
      return await getLanguageDataSource({ dataSource, dataSourceFilter, ssContext, isEditor });
    } else if (!isOnline) {
      return getSupportDataForDataSource(state, {
        index,
        formKey,
        entityName,
        dataSourceName: dataSource.dataSourceName,
        dataSourceFilter,
        dataSourceFilterFromDataSource,
        isGridInitialization,
      });
    } else {
      return await fetchSupportDataSourceFromServer({
        dataSource,
        dataSourceFilter,
        dataSourceFilterFromDataSource,
        ssContext,
        pageLimit,
        isEditor,
        dispatch,
        isGridInitialization,
        disableCache,
      });
    }
  };
}

export const replaceFromChangedDatasource = ({ dataSourcePrevState, dataSourceKey }) => ({
  type: REPLACE_FROM_CHANGED_DATASOURCE_LIST,
  payload: { dataSourcePrevState, dataSourceKey },
});
